import React from 'react'
import { LuLoaderCircle } from 'react-icons/lu'

const Loading = () => {
  return (
    <div className='flex flex-col items-center justify-center w-full h-full gap-2 p-4'>
      <LuLoaderCircle size={24} className='text-slate-500 animate-spin'  />
      <span className="mt-3 text-muted">Cargando...</span>
    </div>
  )
}

export default Loading
